var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"person-web-container"}},[_c('iframe',{staticStyle:{"width":"100vw","height":"100vh","border":"none"},attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }